
const Footer = () => {
    return (

        <footer id="footer">

            <div class="container">

                <div class="copyright-wrap d-md-flex py-4">
                    <div class="me-md-auto text-center text-md-start">
                        <div class="copyright">
                            &copy; Copyright <strong><span>FactorialYou</span></strong>. All Rights Reserved
                        </div>
                    </div>

                </div>

            </div>
        </footer>
    )
};

export default Footer;